import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../../api/client';
import { useToast } from '../../components/ds';
import { Button, Input, Table, Badge } from '../../components/ds';
import CreateAccountModal from './CreateAccountModal';

export default function AccountsPage() {
  const [accounts, setAccounts] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [loading, setLoading] = useState(true);
  const [showCreate, setShowCreate] = useState(false);
  const { addToast } = useToast();
  const navigate = useNavigate();

  const fetchAccounts = useCallback(async () => {
    try {
      const data = await api.getAccounts();
      setAccounts(data || []);
    } catch (err) {
      addToast('Failed to load accounts: ' + err.message);
    } finally {
      setLoading(false);
    }
  }, [addToast]);

  useEffect(() => {
    fetchAccounts();
  }, [fetchAccounts]);

  const filtered = accounts.filter((a) =>
    a.account_name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const formatDate = (dateStr) => {
    if (!dateStr) return '-';
    return new Date(dateStr).toLocaleDateString('zh-TW', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
    });
  };

  const handleCreated = (accountID) => {
    setShowCreate(false);
    addToast('Account created successfully', 'success');
    navigate(`/accounts/${accountID}`);
  };

  if (loading) {
    return <div className="loading">Loading accounts...</div>;
  }

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 24 }}>
        <h1 style={{ fontSize: 24, fontWeight: 700 }}>Accounts</h1>
        <Button onClick={() => setShowCreate(true)}>+ Create Account</Button>
      </div>

      <div style={{ marginBottom: 16 }}>
        <Input placeholder="Search by account name..." value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} />
      </div>

      <Table
        columns={[
          { key: 'account_name', title: 'Account Name', width: '40%' },
          { key: 'account_status', title: 'Status', width: '30%', render: (val) => (
            <Badge variant={val === 'active' ? 'primary' : 'default'}>{val}</Badge>
          )},
          { key: 'CreatedAt', title: 'Created', width: '30%', render: (val) => formatDate(val) },
        ]}
        data={filtered}
        rowKey="uuid"
        onRowClick={(row) => navigate(`/accounts/${row.uuid}`)}
        emptyText="No accounts found"
        loading={loading}
      />

      {showCreate && (
        <CreateAccountModal
          onClose={() => setShowCreate(false)}
          onCreated={handleCreated}
        />
      )}
    </div>
  );
}
